const genericAlarms = new Map([
  ['unreported', 'unreportedAlarms'],
  ['movement', 'movementAlarms'],
  ['speed', 'speedsAlarms'],
  ['parking', 'parkingAlarms'],
  ['geofenceIn', 'geofenceInAlarms']
])

const dataBaseAlarmsMap = new Map([
  ['unreported', 'unreported_event_alarms'],
  ['movement', 'movement_alarms'],
  ['speed', 'alarms'],
  ['parking', 'parking_alarms'],
  ['geofenceIn', 'missions_inside_alarms']
])

const missionsAlarms = new Map([
  ['mission', 'missionAlarms'],
  ['geofenceIn', 'geofenceInAlarms']
])

export {
  dataBaseAlarmsMap,
  genericAlarms,
  missionsAlarms
}



// WEBPACK FOOTER //
// ./src/utils/genericAlarms.js